// extracted by mini-css-extract-plugin
var _1 = "color-swatch__Gteq9";
var _2 = "color-swatch-dark-border__ywP55";
var _3 = "position-relative__mFxEr";
var _4 = "swatch-overlay__EH7JX";
var _5 = "tags-popover__uma1p";
export { _1 as "colorSwatch", _2 as "colorSwatchDarkBorder", _3 as "positionRelative", _4 as "swatchOverlay", _5 as "tagsPopover" }
